import Api from './rest/CrmLeadReminderApi';

export default new Api();
